import { apiClient } from "./client";

/**
 * Fetch all credentials for the current Professional, optionally filtered by type.
 * @param {string} [type] - "EDUCATION" | "WORK" | "OTHER"
 */
export async function listCredentials(type) {
  const res = await apiClient.get("/professional/credentials", {
    params: type ? { type } : {},
  });
  return res.data;
}

/** Fetch a single credential by id. */
export async function getCredential(id) {
  const res = await apiClient.get(`/professional/credentials/${id}`);
  return res.data;
}

/**
 * Create a new credential.
 * @param {object} dto - { type, title, issuer, startDate, endDate, isCurrent, ... }
 */
export async function createCredential(dto) {
  const res = await apiClient.post("/professional/credentials", dto);
  return res.data;
}

/**
 * Update fields on an existing credential. Its type is fixed when it is
 * created and the server refuses the field here, so the forms' shared
 * payload is sent without it.
 */
export async function updateCredential(id, dto) {
  const changes = { ...dto };
  delete changes.type;
  const res = await apiClient.patch(`/professional/credentials/${id}`, changes);
  return res.data;
}

/**
 * Proposes changes to a verified credential and starts paying the
 * verification fee for them (docs/EDIT_POLICY.md). The server sends the
 * change to the verifier who verified it and answers like a verification
 * order (Cashfree's, or { bypass } with payments off).
 */
export async function requestCredentialEdit(id, body) {
  const res = await apiClient.post(
    `/professional/credentials/${encodeURIComponent(id)}/request-edit`,
    body,
  );
  return res.data;
}

/** Soft-delete a credential. */
export async function deleteCredential(id) {
  const res = await apiClient.delete(`/professional/credentials/${id}`);
  return res.data;
}
